// extracted by mini-css-extract-plugin
export default {"container":"CharacterDetails_container__sCWz0","divdatos":"CharacterDetails_divdatos__qDY0j","datos":"CharacterDetails_datos__YZgSK"};